// extracted by mini-css-extract-plugin
export var badgeContainer = "unavailable-badge-module--badgeContainer--Kp931";
export var badgeSans = "unavailable-badge-module--badgeSans--4WjDP";
export var badgeSerif = "unavailable-badge-module--badgeSerif--NSGlz";
export var badgeText = "unavailable-badge-module--badgeText--B1yZH";